import { isTestBidderAvailable } from '@pubstack/common/src/pbs/pbs-test-bidder'
import { ScopeId } from '@pubstack/common/src/scope'
import { FunctionComponent } from 'react'
import { useAdminScope } from '~/api/admin/admin-scope.api'
import { useAdminSiteTestBidder, useUpdateAdminSiteTestBidder } from '~/api/admin/admin-site.api'
import PureAdminScopeSiteSetupFlyout from './PureAdminScopeSiteSetupFlyout'
import { useSiteSetup } from './useSiteSetup'

type Props = {
  scopeId: ScopeId
  siteId: string
}

export const AdminScopeSiteSetupFlyout: FunctionComponent<Props> = ({ scopeId, siteId }) => {
  // Hooks
  const { site, isInitialLoading, isDownloading, mappingExportLoading, mappingExport, refetchMappingExport, downloadMappingExport } = useSiteSetup(scopeId, siteId)
  // The scope of the URL, not the viewer's current scope: an admin edits sites of any scope.
  const { data: scope } = useAdminScope(scopeId)
  const available = !!site && !!scope && isTestBidderAvailable(site, { onboardedFeatures: scope.onboardedFeatures, userAccessFeatures: scope.userAccessFeatures })
  const { data: testBidder } = useAdminSiteTestBidder(scopeId, siteId)
  const { mutateAsync: updateTestBidder } = useUpdateAdminSiteTestBidder(scopeId, siteId, {
    successToast: 'Server-side test bidder was successfully updated',
    errorToast: 'Something went wrong when trying to update the server-side test bidder',
  })

  return (
    <PureAdminScopeSiteSetupFlyout
      isInitialLoading={isInitialLoading}
      isDownloading={isDownloading}
      site={site}
      mappingExportLoading={mappingExportLoading}
      mappingExport={mappingExport}
      isTestBidderAvailable={available}
      testBidderEnabled={testBidder?.enabled}
      testBidderEnabledByScope={testBidder?.enabledByScope}
      onTestBidderChange={(enabled) => updateTestBidder({ enabled })}
      onRefreshClick={refetchMappingExport}
      onDownloadClick={downloadMappingExport}
    />
  )
}
